export default "/images/performancefinance-header.png";